import React from 'react';

import type {Feature} from '../../generated/types';
import {composeDescription, Crumb, EntitySeo, SectionKey} from '../../lib/seo';
import type {OgCardData} from '../../lib/seo';

type FeatureLike = Pick<Feature, 'id' | 'title' | 'originalTitle' | 'alternativeTitles' | 'description' | 'levels'>;

type Props = {
	feature: FeatureLike;
	section: SectionKey;
	/** чьё это умение — в заголовке: «умение воина», «манёвры воина», «особенность вида Эльф» */
	owner: string;
	/** начало описания: «Умение класса Воин» */
	lead: string;
	/**
	 * Каноничный адрес — страница владельца: модалка с умением открывается только в браузере,
	 * а на сервере по адресу умения рендерится та же страница, где этот текст уже есть.
	 */
	canonicalPath: string;
	/** крошки от раздела до умения включительно */
	crumbs: Crumb[];
};

function levelText(feature: FeatureLike): string {
	const level = feature.levels?.[0];
	return level ? `, ${level}-й уровень` : '';
}

/** SEO отдельного умения: у ссылки на него в мессенджере будет своё название и описание */
export const FeatureSeo: React.FC<Props> = ({feature, section, owner, lead, canonicalPath, crumbs}) => (
	<EntitySeo
		entity={{...feature, alternativeTitles: feature.alternativeTitles || []}}
		section={section}
		kind={`${owner},`}
		description={composeDescription(`${lead}: ${feature.title}${levelText(feature)}.`, feature.description)}
		path={canonicalPath}
		og={{kind: 'feature'}}
		crumbs={crumbs}
	/>
);

export function featureOgCard(feature: FeatureLike): OgCardData {
	const level = feature.levels?.[0];
	return {
		label: 'Умение',
		title: feature.title,
		originalTitle: feature.originalTitle,
		subtitle: level ? `${level}-й уровень` : null,
	};
}
